import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import type { ReportBuilderResult } from './hooks/useReportBuilder';

function coerceNumeric(value: string | number): number | null {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function formatReportCellValue(
  value: string | number | boolean | null | undefined,
  format?: 'decimal',
): string {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (format === 'decimal' || typeof value === 'number') {
    const numeric = coerceNumeric(value as string | number);
    if (numeric !== null) {
      return numeric.toLocaleString('en-CA', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
  }
  return String(value);
}

export function exportBuilderResultToExcel(result: ReportBuilderResult, reportName?: string): void {
  const headers = result.columns.map((col) => col.label);
  const rows = result.rows.map((row) =>
    result.columns.map((col) => formatReportCellValue(row[col.id], col.format)),
  );
  const wsData = [headers, ...rows];
  const ws = XLSX.utils.aoa_to_sheet(wsData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Report');
  const wbOut = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbOut], { type: 'application/octet-stream' });
  const filename = `${reportName || 'report'}-${new Date().toISOString().slice(0, 10)}.xlsx`;
  saveAs(blob, filename);
}
